import { type ISlot } from '../../../../models/DistributionPlan'

export type MajorWarningId = 'surveyEndsBeforeTerm'

export interface MajorWarning {
  id: MajorWarningId
  /** Short label for multi-warning numbered list */
  listTitle: string
  /** Bold primary line when this is the only warning */
  singlePrimaryHeading: string
  detailLines: string[]
  recommended: string
}

export function isSurveyEndBeforeTermEnd (
  termEndTimestamp: string | Date | undefined | null,
  surveyEndTimestamp: string | Date | undefined | null
): boolean {
  const termEnd = termEndTimestamp ? new Date(termEndTimestamp) : null
  const surveyEnd = surveyEndTimestamp ? new Date(surveyEndTimestamp) : null
  return Boolean(termEnd && surveyEnd && surveyEnd < termEnd)
}

const SURVEY_BEFORE_TERM_WARNING: Omit<MajorWarning, 'id'> = {
  listTitle: 'Survey project ends before the term ends',
  singlePrimaryHeading: 'We detected that your Survey Project ends before the term ends.',
  detailLines: [
    'Course sections that end after this project closes may have shortened evaluation periods or may not receive an evaluation. If you plan to add course sections later in the term, please follow the recommendation below.'
  ],
  recommended: 'Extend the Survey Project end date to after the term end date, or to when the last course section survey should end.'
}

export function buildMajorWarnings (
  slot: Pick<ISlot, 'slotEndTimestamp'> | undefined,
  termEndTimestamp: string | Date | undefined | null
): MajorWarning[] {
  const warnings: MajorWarning[] = []
  if (isSurveyEndBeforeTermEnd(termEndTimestamp, slot?.slotEndTimestamp)) {
    warnings.push({ id: 'surveyEndsBeforeTerm', ...SURVEY_BEFORE_TERM_WARNING })
  }
  return warnings
}
